import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from 'src/app/core/api/api.service';

@Injectable({
  providedIn: 'root'
})
export class PreciosOrdenesFisicasService {

  private readonly base = '/company/physical-order-prices';

  constructor(private api: ApiService) {}

  // `_token` es legacy y se ignora (el token va en el header Bearer).

  listarPrecios(_token?: any): Observable<{ rows: any[] }> {
    return this.api.post(`${this.base}/list`, {});
  }

  crearPrecio(valor: string, idTipoPrecio: string, _token?: any): Observable<{ id: number }> {
    return this.api.post(`${this.base}/create`, { valor, idTipoPrecio });
  }

  editarPrecio(idPrecio: string, valor: string, idTipoPrecio: string, _token?: any): Observable<{ id: number }> {
    return this.api.post(`${this.base}/update`, { id: idPrecio, valor, idTipoPrecio });
  }

  eliminarPrecio(idPrecio: string, _token?: any): Observable<{ id: number }> {
    return this.api.post(`${this.base}/delete`, { id: idPrecio });
  }

  listarPreciosPorTipo(_token: any, idTipoPrecio: string): Observable<{ rows: any[] }> {
    return this.api.post(`${this.base}/list`, { field: 'FK_COD_TIPPREC', value: idTipoPrecio });
  }
}
